import {
  generateFedexPinInputSchema,
  generateFedexPinOutputSchema,
} from "@redotech/redo-model/fulfillments/fedex-customer-registration";

export const generateFedexPin = {
  name: "generateFedexPin" as const,
  input: generateFedexPinInputSchema,
  output: generateFedexPinOutputSchema,
};
